export const InvoicesAgGridMixin = {
    methods: {
        $_actionParameterCellRenderer(params, refreshServerSide) {
            return { ...params.data, refreshServerSide };
        }
    }
};
